module.exports = __webpack_public_path__ + "static/media/cloud.6fc3c835.png";